import { getAppSettings } from 'common/settings';

/* Уход на лендинг из настройки сборки без записи в историю: «назад» не возвращает на пустой адрес. */
export const redirectToLanding = () => window.location.replace(getAppSettings().landingUrl);
